import { css, styled } from 'styled-components';

import { blue } from 'enable-ui';

const AuthContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 0;
  width: 100%;
  min-height: 100vh;
  background-color: #f7f4ed;
`;

const AuthBody = styled.div`
  margin-top: 32px;
  border: 1px solid #00000040;
  border-radius: 16px;
  padding: 32px;
  width: 440px;
  background: #fffdf7;
`;

export const TitleLink = styled.span<{
  color?: string;
}>`
  ${({ color }) => {
    const linkColor = color ?? blue['blue-6'];

    return css`
      font-size: 18px;
      font-weight: 400;
      line-height: 26px;
      cursor: pointer;
      color: ${linkColor};
      margin-left: 4px;
      &:hover {
        text-decoration-line: underline;
      }
    `;
  }}
`;

export { AuthContainer, AuthBody };
